import type { FC } from 'react'
import type { ChevronProps } from './Chevron'
import Chevron from './Chevron'
import { CwsIcon } from '@components/cws'

export interface SpoilerChevronProps extends Omit<ChevronProps, 'direction'> {
  open?: boolean
}

export const SpoilerChevron: FC<SpoilerChevronProps> = (props) => {
  const { open = false, ...restProps } = props

  return (
    <>
      {open ? (
        <CwsIcon className="cws-ml-4" color="buoy-dark" icon="arrow-up" size="10px" />
      ) : (
        <CwsIcon className="cws-ml-4" color="buoy-dark" icon="arrow-down" size="10px" />
      )}
    </>
  ) //<Chevron {...restProps} direction={open ? 'up' : 'down'} />
}

export default SpoilerChevron
